import OrdersModule from './orders'

export function regiesterRest(store: any) {
  store.registerModule(
    'orders',
    OrdersModule,
  )
}
